import React, { useMemo } from 'react';
import { find, findIndex } from 'lodash';
import PropTypes from 'prop-types';
import { Button, CardContent, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';

const UnverifiedEmail = ({ ...props }) => {
  const { stepToRender, setCurrentStep } = props;
  const { payload = {} } = stepToRender;
  const { callbacks = [] } = payload;

  // get index of the choice callback; holds navigation options.
  const confirmationCallbackIndex = useMemo(() => {
    let output;

    if (stepToRender) {
      output = findIndex(
        stepToRender?.payload?.callbacks,
        (callbackObj) => callbackObj?.type?.toLowerCase() === 'confirmationcallback'
      );
    }

    return output;
  }, [stepToRender]);

  // get the navigation options in the confirmation callback
  const navigationButtons = useMemo(() => {
    let output;

    if (confirmationCallbackIndex >= 0) {
      output = find(callbacks[confirmationCallbackIndex]?.output, (outputObj) => outputObj.name === 'options')?.value;
    }

    return output || [];
  }, [confirmationCallbackIndex]);

  const handleNavigation = (selectedNavigation) => {
    const nextStep = { ...stepToRender };

    // get the index of the selected navigation option
    const selectedNavigationIndex = findIndex(
      navigationButtons,
      (button) => button?.toLowerCase() === selectedNavigation?.toLowerCase()
    );

    const newCallbacks = [...callbacks];

    if (selectedNavigationIndex >= 0) {
      // set the value of the navigation in the input of the confirmation callback
      newCallbacks[confirmationCallbackIndex].input[0] = {
        ...newCallbacks[confirmationCallbackIndex].input[0],
        value: selectedNavigationIndex,
      };
    }

    // overwrite the old callbacks with the newly constructed callbacks
    Object.assign(nextStep.payload.callbacks, newCallbacks);

    // set the current step to trigger the navigation
    setCurrentStep({ ...nextStep });
  };

  return (
    <Grid
      id="unverified-email-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        size={{ xs: 12, sm: 12, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        sx={{ minHeight: '100vh' }}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '600px' } }}>
            <CardContent>
              <Typography variant="h1" mb={2}>
                Email address not validated
              </Typography>
              <Typography variant="subtitle1" mb={5}>
                An email address has yet to be validated as associated with your account.
              </Typography>
              <Grid display="flex" justifyContent="end" flexWrap="wrap">
                <Button
                  color="secondary"
                  onClick={() => handleNavigation('change-email')}
                  sx={{ marginBottom: { xs: 1, md: 0 } }}
                >
                  Send to a Different Email Address
                </Button>
                <Button color="primary" onClick={() => handleNavigation('resend')} sx={{ marginLeft: 1 }}>
                  Send Validation Email
                </Button>
              </Grid>
            </CardContent>
          </Paper>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

UnverifiedEmail.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default UnverifiedEmail;
